import { Injectable } from '@angular/core';
import {
  SharedBaseTaskViewerService,
} from '@sbd-doug-frontend/shared/lib/shared-services/shared-base-task-viewer.service';

@Injectable({
  providedIn: 'root',
})
export class MyTasksetService extends SharedBaseTaskViewerService {
  constructor() {
    super();
  }
}
